var Plugin = require("common/Plugin");
var NetworkPlacesController = require("./NetworkPlacesController");
var NetworkPlaceLauncher = require("./NetworkPlaceLauncher");

var NetworkPlacesPlugin = function() {
    var self = this;

    this.start = function() {
        var controller = new NetworkPlacesController(CudaLaunch.models.resources);
        controller.registerLauncher(new NetworkPlaceLauncher());
        self.registerController(controller);
    };
};

NetworkPlacesPlugin.prototype = Plugin;

module.exports = NetworkPlacesPlugin;